<template>
  <SiteBrand />
  <main>
    <SceneHero />
    <SceneOpening />
    <SceneCarrara />
    <SceneTimeline />
    <SceneSources />
  </main>
  <SceneFooter />
</template>

<script setup lang="ts">
import SiteBrand from './components/SiteBrand.vue';
import SceneHero from './components/SceneHero.vue';
import SceneOpening from './components/SceneOpening.vue';
import SceneCarrara from './components/SceneCarrara.vue';
import SceneTimeline from './components/SceneTimeline.vue';
import SceneSources from './components/SceneSources.vue';
import SceneFooter from './components/SceneFooter.vue';
</script>

<style scoped>
main { min-height: 100vh; }
</style>
